










































import { Vue, Component, Prop } from "vue-property-decorator";

import { UserProfile } from "@api/models/UserProfile";
import { escapeHtml } from "@common/MessageProcessor";
import { Tag } from "@api/models/Tag";
import TagList from "@share/common/tag-list/TagList.vue";
import Description from "@share/common/Description.vue";

@Component({
    name: 'ChatProfile',
    components: { TagList, Description }
})
export default class ChatProfileContent extends Vue {

    @Prop({ required: true }) profile: UserProfile;

    @Prop({}) lookingForTags: {tag: Tag;}[];
    @Prop({}) offerTags: {tag: Tag;}[]

    get biography() {
        if (this.profile) {
            const text = (this.profile as any).biography || '';
            return escapeHtml(text);
        }
        return '';
    }

}
